///<reference path="./smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="collection-model.ts"/>
///<reference path="collection-base.ts"/>


module Meevo.Components.Controls.SmartMover {

    export class CollectionOptimizedApi<T> extends SmartMoverApiCollection<T> implements IApiCollection<T> {
        protected _selectedModels: CollectionModel<T>[];
        protected _value: ModelValueType[];
        protected $scope: ng.IScope;

        get selectedModels() {
            return this._selectedModels;
        }

        get value(): ModelValueType[] {
            return this._value;
        }

        constructor(public connectedModel: ModelValueType[], items: T[] = [], options: ICollectionOptions<T> = {}, $scope: ng.IScope) {
            super(connectedModel, items, options);

            this._selectedModels = [];
            this._value = [];
            this.$scope = $scope;
        }

        public setSelectedValue(selected: boolean): void {
            if (this.childCollection) {
                this.childCollection.setSelectedValue(selected);
            }

            this.models.forEach((model) => {
                model.selected = selected;
            });

            if (selected) {
                this._selectedModels = this.allModelsList;
            } else {
                this._selectedModels = [];
            }
            this._value = this._selectedModels;

            this.resetCollection(this.value);
        }

        setWatchers(scope: angular.IScope) {
            scope.$watch(() => this.moverHidden, (hidden?: boolean) => {
                if (hidden === false) {
                    this.filterList();
                }
            });
        }

        public updateCollectionFromModel(modelValues: ModelValueType[]): void {
            super.updateCollectionFromModel(modelValues);

            this.onModelValueChanged();
        }

        public onModelValueChangedSoft() {
            this._selectedModels = this.allModelsList.filter((model) => model.selected);

            this._value = this._selectedModels;

            this.resetCollection(this.value);
        }

        public onModelValueChanged = _.debounce(() => {
            this.$scope.$apply(() => {
                this.onModelValueChangedSoft();
            });
        }, 100);
    }
}
